const leadPreferences = {
  leadPreferences: {
    pageHeader: 'Preferencias de clientes potenciales',
    confirmMessage:
      '¿Está seguro que desea guardar sus preferencias de clientes potenciales e ir a la página de Añadir usuario?',
    notInterested: {
      radioOptions0: 'Falta de tiempo/recursos para brindar atención a nuevos clientes potenciales',
      radioOptions1: 'Solo interesado en contratos firmados por propietarios de vivienda',
      radioOptions2: 'No deseo divulgar el rango de precios',
      radioOptions3: 'Otro',
      selectReason: 'Seleccione una razón por la que desea salir del Programa de Clientes Potenciales de Enphase',
      otherComments: 'Cualquier otro comentario'
    },
    programOverview: {
      notInterestedText: 'No estamos interesados en participar en el Programa de Contactos de Enphase por el momento'
    },
    serviceDetailsSection: {
      min: 'Mín.',
      max: 'Máx.',
      maxLessMin: 'El valor Máximo no puede ser menor o igual que el valor Mínimo',
      enterInRange: 'Ingrese solo números entre %{serviceMInValue} y %{serviceMaxValue}',
      note: 'Nota',
      noteText:
        'Se mostrará un rango de precios al propietario en base a esta información. Este precio debería incluir impuestos pero no incentivos.',
      noteTextAus:
        'Se mostrará un rango de precios al propietario en base a esta información. Este precio debería incluir IVA pero no incentivos.',
      sizeRange: 'Rango de tamaño',
      pricePerkWh: 'Precio por kWh',
      lessThan20kWh: 'Menos de 20 kWh',
      greaterThan20kWh: 'De 20 a 40 kWh'
    },
    serviceAreaSection: {
      title: 'Acceso como administrador y área de servicio',
      manageAdminAccess: 'Gestionar acceso como administrador',
      addNewUser: '+ Añadir nuevo usuario',
      selectOneAdmin:
        'Seleccione un usuario administrador de su compañía que será el único punto de contacto en caso que Enphase quiera contactarse con usted por consultas relacionadas con cualquier cliente potencial.',
      selectUser: 'Seleccionar usuario',
      otherAdmin:
        '#Los otros usuarios administradores en la lista anterior están recibiendo alertas por todos los clientes potenciales nuevos y sus actualizaciones. Pueden desactivarlas actualizando sus preferencias de notificaciones en caso de ser necesario.',
      serviceArea: 'Área de servicio',
      addServiceAreas: ''
    },
    addUserDialog: {
      yes: 'Sí'
    },
    acModule: {
      optIn: 'Aceptar la instalación de Módulos de CA energizados de Enphase',
      description:
        'El propietario de vivienda expresa interés en un sistema en base a Módulos de CA. Usted conseguirá e instalará los Módulos de CA. Los Módulos de CA energizados de Enphase combinan la tecnología de microinversores de vanguardia de Enphase con los Paneles solares de alta eficiencia. Combinan la estética y el rendimiento en un producto elegante que reduce el tiempo de instalación combinando el inversor y el panel en una única unidad.'
    },
    sampleQuotes: {
      title: 'Precios indicativos para clientes potenciales',
      useSlider:
        'Use las barras deslizantes a continuación para ver cómo la información que aporte sobre los rangos de precios se traducen en un rango de precios indicativo para los propietarios de vivienda para diferentes tamaños de sistemas',
      description:
        'En base a su información aportada, el rango de precios indicativo que los propietarios de vivienda verán se mostrará aquí. Además, puede verificar cómo variará el rango de precios según el tamaño del sistema.',
      solarOnly: 'Instalación solar',
      storageOnly: 'Instalación de almacenamiento',
      solarStorage: 'Instalación solar + almacenamiento',
      solarExpansion: 'Ampliación solar',
      turnkeyACM: 'Instalación de almacenamiento + Actualización de ACM',
      microUpgrade: 'Actualización de microinversor',
      turnkeyIQSeries: 'Instalación de almacenamiento + Actualización de microinversores',
      installationACM: 'Instalación de almacenamiento + Actualización de ACM',
      installationIQSeries: 'Instalación de almacenamiento + Actualización de microinversores',
      installationSolar: 'Instalación solar',
      installationStorage: 'Instalación/Ampliación de almacenamiento',
      turnkeyNew: 'Precio llave en mano para nuevos propietarios de vivienda',
      turnKeyExisting: 'Precio llave en mano para propietarios de vivienda existentes',
      turnkeyNewUS: 'Precio llave en mano para propietarios de viviendas',
      installationUS: 'Precio de sólo la instalación para propietarios de viviendas',
      installation: 'Cotizaciones solo por instalación para clientes de M-190 Micro',
      turnkeyPrice: 'Precio llave en mano',
      installation2: 'Precio solo por instalación para clientes recomendados',
      installation3: 'Precio solo por instalación para propietarios existentes',
      microinverterFootnote:
        'El precio de la actualización del microinversor puede añadirse dependiendo de la antigüedad del sitio',
      solar: 'Solar',
      storage: 'Almacenamiento'
    },
    operationMaintenance: {
      label: 'Aceptar los Servicios de O&M',
      description:
        'Los servicios de operaciones y mantenimiento (O&M) incluyen el soporte y mantenimiento de sistemas de Enphase existentes y Sistemas Orphan (sitios con un instalador inactivo). Se le proporcionará a todos los clientes potenciales de O&M detalles completos del sitio e historial de soporte. Para todos los clientes potenciales de O&M, se aplicará la garantía del producto estándar de Enphase. La garantía de fabricación previa no se aplicará para los Sistemas Orphan.'
    },
    leadProgram: {
      optIn: 'Aceptar el Programa de Clientes Potenciales de Enphase',
      description:
        'Los propietarios de vivienda deben contactarse con Enphase por nuevas instalaciones, actualizaciones y mantenimiento continuo de sistemas. Como socio de Enphase, ahora tiene la oportunidad de brindar servicios a estos propietarios de vivienda a través del Programa de Clientes Potenciales de Enphase, que lo contactará con posibles propietarios de vivienda.',
      programHighlights: 'Aspectos destacados del programa:',
      keyTerms1: 'Enphase proporcionará gratis clientes potenciales calificados de su área de servicio',
      keyTerms2:
        'Se proporcionarán detalles del perfil del cliente y del proyecto para cada cliente potencial antes del primer contacto',
      keyTerms3: 'Enphase ayudará con la programación, citas, actualizaciones de proyectos y soporte técnico',
      keyTerms4:
        'Se espera que los instaladores respondan y se contacten con cada cliente potencial y envíen una cotización en menos de dos días hábiles',
      keyTerms5: 'Como parte del programa, solo se usarán los productos de Enphase',
      leadProgramPreferences: 'Preferencias del programa de clientes potenciales',
      someLeads:
        'Algunos clientes potenciales podrían requerir solo servicios de instalación. Indique a continuación si desea aceptar dichos clientes potenciales.',
      tooltipTitle1:
        'Servicios que proporciona a propietarios de vivienda. Enphase lo pondrá en contacto con propietarios de vivienda en base a sus preferencias de servicio seleccionadas',
      turnKey: 'Servicios llave en mano',
      tooltipTitle2: 'Usted proporciona todo el equipo, diseño, permisos y servicios de instalación',
      installationService: 'Servicios de instalación solamente',
      tooltipTitle3:
        'El propietario de vivienda elige conseguir el equipo de Enphase en la tienda de Enphase. Usted proporciona el resto del equipo, diseño, permisos y servicios de instalación',
      solarNew: 'Energía solar – Nuevas instalaciones',
      solarUpgrades: 'Energía solar - Actualizaciones',
      storageNew: 'Almacenamiento - Nuevas instalaciones'
    },
    textContent: {
      preference: {
        title: 'Preferencias del programa de clientes potenciales',
        caption: 'Descargo de responsabilidad',
        description:
          'Enphase mostrará el rango de precios proporcionado por usted para cada preferencia a continuación a los propietarios de vivienda. Se mostrará con un descargo de responsabilidad de que este precio es un presupuesto y refleja el alcance del trabajo para un sistema típico solamente.  El precio real está sujeto a cambios, dependiendo de la ubicación, tipo/altura del techo, actualización del panel eléctrico y reubicación del sistema a un lugar diferente.',
        atleaseOne: '* seleccione al menos un servicio'
      },
      programreview: {
        title: 'Descripción general del programa',
        description:
          'Los propietarios de vivienda deben contactarse con Enphase por nuevas instalaciones, actualizaciones y mantenimiento continuo de sistemas. Como socio de Enphase, ahora tiene la oportunidad de brindar servicios a estos propietarios de vivienda a través del Programa de Clientes Potenciales de Enphase que lo combina con posibles propietarios de vivienda. Revise los términos clave a continuación y especifique sus preferencias para este programa.'
      },
      keyProgramTerms: {
        title: 'Términos clave del programa',
        enphaseProduct: 'Como parte del programa, solo se usarán los productos de Enphase',
        appointment: 'Enphase le ayudará a programar citas y proporcionará más ayuda según sea necesario',
        contact: 'Se espera que los instaladores se contacten con cada cliente potencial en menos de dos días hábiles',
        project:
          'Se proporcionarán detalles del perfil del cliente y del proyecto para cada cliente potencial antes del primer contacto',
        verifiedAccount: 'Enphase proporcionará gratis clientes potenciales calificados de su área de servicio'
      },
      TurnKey: {
        title: 'Servicios llave en mano',
        description:
          'Servicios llave en mano significa que el instalador proporciona todas la lista de materiales, diseños, permisos, instalación y puesta en servicio según corresponda. El instalador evalúa el proyecto y el sitio antes de proporcionar una cotización detallada. El precio indicado incluye el costo estimado total al propietario de vivienda por el sistema a activar.',
        solar: {
          indicativePricing: 'Rango de precios indicativo por Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Instalación',
          sub: 'Una nueva instalación de sistema solar',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub:
                'Proporciona precios llave en mano y consigue toda la lista de materiales, tales como módulos, microinversores (o alternativamente módulos CA), caja IQ\u200b Combiner, kit de accesorios, disyuntores de circuitos, módem celular, cables y gabinete.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios es para un sitio típico y no incluye una actualización del panel principal y techo de tipo especial.'
            }
          }
        },
        storage: {
          indicativePricing: 'Rango de precios indicativo por kWhr',
          indicativePricingStorageSlabs: 'Precio indicativo por kWh',
          main: 'Almacenamiento - Instalación',
          quoteSizeIn: 'kWh',
          sub: 'Una nueva instalación de sistema de almacenamiento',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub:
                'Proporciona precios llave en mano y consigue toda la lista de materiales, tales como almacenamiento Encharge, interruptor Enpower, módem celular, kit de accesorios y cables\u200b.'
            },
            assumptions: {
              main: 'Supuestos',
              sub: 'El rango de precios indicativo no incluye la actualización del panel principal.'
            }
          }
        },
        microinverter: {
          indicativePricing: 'Rango de precio indicativo por Watt',
          main: 'Microinversor - Actualización',
          quoteSizeIn: 'kW',
          sub:
            'Actualización de microinversor para un sistema solar basado en la serie M (por ejemplo, M-215, M-250) a un nuevo sistema solar basado en IQ que generalmente acompaña a un "Almacenamiento - Instalación"',
          sub2:
            'Actualización del microinversor para un sistema solar basado en la serie M (por ejemplo, M-215, M-250) a un nuevo sistema solar basado en IQ',
          subUS:
            'Actualización del microinversor para un sistema solar existente para convertirlo en un nuevo sistema solar basado en IQ.',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona precios llave en mano y consigue toda la lista de materiales requeridos.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal y actualizaciones del panel solar.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Solo servicios de instalación (para programas especiales)',
        titleUS: 'Servicios de sólo instalación',
        sub: '(por ejemplo, Propietarios de vivienda con paneles solares en base a M-190, Amigos y familia de Enphase)',
        description:
          'Solo servicios de instalación significa que el propietario de vivienda consigue la lista de materiales de Enphase de la tienda de Enphase. Todos los demás materiales y servicios son proporcionados directamente por el instalador (cableado, gabinetes, diseño, permisos, instalación y puesta en servicio según corresponda).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          main: 'Solar - Instalación',
          sub:
            'Nueva instalación para programas especiales o actualización completa de un sistema solar en base a M-190/M-210/M-175/D380',
          subUS: 'Una nueva instalación de sistema solar',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase\u200b, tales como módulos de CA, caja IQ\u200b Combiner, kit de accesorios y disyuntores de circuitos.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona gabinete, cableado, permisos, instalación y puesta en servicio.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal e instalación de techo de tipo especial.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          indicativePricingStorageSlabs: 'Precio indicativo por kWh de sólo instalación',
          main: 'Almacenamiento - Instalación',
          sub:
            'Adición de almacenamiento a un sistema solar existente para programas especiales o para un sistema solar en base a M-190/M-210/M-175/D380',
          subUS: 'Una nueva instalación de sistema de almacenamiento',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase, tales como almacenamiento Encharge, interruptor Enpower, kit de accesorios, pasarela Envoy (en caso de ser necesario caja IQ\u200b Combiner, módem celular y/o CT de consumo)\u200b.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona permisos, instalación y puesta en servicio.'
            },
            assumptions: {
              main: 'Supuestos',
              sub: 'El rango de precios indicativo no incluye la actualización del panel principal.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          main: 'Microinversores - Actualización',
          sub: `Mise à jour des micro-onduleurs pour un système installé en M série (par exemple M-215, M-250) vers un  système en IQ série"`,
          sub2:
            'Actualización del microinversor para un sistema solar basado en la serie M (por ejemplo, M-215, M-250) a un nuevo sistema solar basado en IQ',
          subUS:
            'Actualización del microinversor para un sistema solar existente para convertirlo en un nuevo sistema solar basado en IQ.',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase\u200b, tales como microinversores, caja IQ\u200b Combiner, kit de accesorios y disyuntores de circuitos.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona permisos, reemplazos, nueva puesta en servicio y reciclaje de microinversores viejos.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal y cambios de gabinete.'
            }
          }
        }
      },
      omServices: {
        title: 'Servicios de O&M de Enphase',
        om: {
          main: 'Aceptar los Servicios de O&M de Enphase',
          pre: -'Incluidos los Sistemas Orphan',
          sub:
            'Los servicios de operaciones y mantenimiento (O&M) incluyen el soporte y mantenimiento de sistemas de Enphase existentes y Sistemas Orphan (sitios con un instalador inactivo). Se le proporcionará a todos los clientes potenciales de O&M detalles completos del sitio e historial de soporte. Para todos los clientes potenciales de O&M, se aplicará la garantía del producto estándar de Enphase. La garantía de fabricación previa no se aplicará para los Sistemas Orphan.'
        }
      },
      otherServices: {
        title: 'Otras preferencias',
        buy: 'Estamos dispuestos a comprar productos de',
        acModule: {
          main: 'Estamos dispuestos a instalar módulos de CA energizados de Enphase',
          sub1: 'Los Módulos de CA energizados de Enphase\xa0',
          sub2:
            'combinan la tecnología más reciente de microinversores de Enphase con los Paneles solares de alta eficiencia. Combinan estética y rendimiento en un producto elegante que reduce el tiempo de instalación al combinar el inversor y panel en una única unidad. Al seleccionar esta opción, Enphase lo contactará con los propietarios de vivienda que estén dispuestos a instalar Módulos de CA.'
        },
        enstore: {
          main: 'Tienda de Enphase',
          sub1: 'La Tienda de Enphase\xa0',
          sub2:
            'es un centro integral para productos Solares y de Almacenamiento con entrega garantizada. La Tienda no requiere una cantidad mínima de pedido y proporciona una entrega en tiempo real y seguimiento en línea.',
          subIndia: `is a one-stop-shop for Solar products with guaranteed delivery. Store requires no minimum order quantity and provides real time delivery and online tracking.​`
        },
        distributor: {
          main: 'Distribuidores de Enphase',
          sub1: 'Los Distribuidores de Enphase',
          sub2:
            '\xa0suministran todos los productos de Enphase y otros accesorios requeridos para su solución Solar y de Almacenamiento',
          subIndia: ` supply all Enphase products and other required accessories for your Solar solution​`
        },
        permitAssistance: {
          main: 'Estamos interesados en el Servicio de Asistencia de Permisos de Enphase',
          sub:
            'Enphase lo ayudará con los Paquetes de permisos solares y de almacenamiento para sus sitios que puede presentar ante su autoridad local para su aprobación.'
        },
        financeProvider: {
          main: 'Ofrecemos opciones de financiación para propietarios de viviendas',
          no: 'No',
          yes: 'Sí',
          financeProvider: 'Proveedores de financiación',
          others: 'Otros proveedores',
          addMultiple: 'hasta 3 (separados por comas)',
          requiredSelection: 'Se requiere Selección',
          atLeastOneError: `Proveedores de finanzas no válidos (al menos ingrese el nombre de un proveedor cuando se seleccione "Otros proveedores")`
        }
      },
      serviceArea: {
        name: 'AÑADIR ÁREAS DE SERVICIO',
        sub: 'No se añadieron áreas',
        description:
          'Añada sus áreas de servicio. Esto es necesario para que Enphase pueda conectarlo con clientes potenciales propietarios de vivienda.'
      },
      qualifyLeads: {
        mainSection: '¿Quiere que los representantes de Enphase califiquen a los clientes potenciales mediante una llamada telefónica antes de compartirlos con usted?',
        moreInfo: 'Indíquenos si hay alguna información específica que desee que recopilemos para sus clientes potenciales.',
        infoWeCollect: 'Para saber qué información recopilamos como parte de nuestros procedimientos de calificación',
        subSection: 'Tras la calificación, ¿desea que traslademos la llamada del cliente potencial a uno de sus representantes mientras el propietario está hablando por teléfono con nosotros?',
        details: 'Seleccione un usuario administrador de su empresa al que quiera que se transfieran las llamadas de dichos clientes potenciales',
        icCheckList: 'Qualification Checklist',
        selectOption: 'Please select an option',
        selectUser: 'Please select a user',
      }
    },
    textContentAu: {
      preference: {
        title: 'Preferencias del programa de clientes potenciales',
        caption: 'Descargo de responsabilidad',
        description:
          'Enphase mostrará el rango de precios proporcionado por usted para cada preferencia a continuación a los propietarios de vivienda. Se mostrará con un descargo de responsabilidad de que este precio es un presupuesto y refleja el alcance del trabajo para un sistema típico solamente. El precio real está sujeto a cambios, dependiendo de la ubicación, tipo/altura del techo, actualización del panel eléctrico y reubicación del sistema a un lugar diferente.',
        atleaseOne: '* seleccione al menos un servicio'
      },
      programreview: {
        title: 'Descripción general del programa',
        description:
          'Los propietarios de vivienda deben contactarse con Enphase por nuevas instalaciones, actualizaciones y mantenimiento continuo de sistemas. Como socio de Enphase, ahora tiene la oportunidad de brindar servicios a estos propietarios de vivienda a través del Programa de Clientes Potenciales de Enphase que lo combina con posibles propietarios de vivienda. Revise los términos clave a continuación y especifique sus preferencias para este programa.'
      },
      keyProgramTerms: {
        title: 'Términos clave del programa',
        enphaseProduct: 'Como parte del programa, solo se usarán los productos de Enphase',
        appointment: 'Enphase le ayudará a programar citas y proporcionará más ayuda según sea necesario',
        contact: 'Se espera que los instaladores se contacten con cada cliente potencial en menos de dos días hábiles',
        project:
          'Se proporcionarán detalles del perfil del cliente y del proyecto para cada cliente potencial antes del primer contacto',
        verifiedAccount: 'Enphase proporcionará gratis clientes potenciales calificados de su área de servicio'
      },
      TurnKey: {
        title: 'Servicios llave en mano',
        description:
          'Servicios llave en mano significa la provisión de una lista de materiales, diseño del sistema, permisos, instalación y puesta en servicio según corresponda. El instalador evalúa el proyecto y el sitio antes de proporcionar una cotización detallada. El precio indicado debería incluir el costo estimado total al propietario de vivienda por una activación de sistema',
        solar: {
          indicativePricing: 'Rango de precios indicativo por Watt',
          quoteSizeIn: 'kW',
          main: 'Solar - Instalación',
          sub: 'Una nueva instalación de sistema solar',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub:
                'Proporciona precios llave en mano y consigue toda la lista de materiales, tales como módulos, microinversores, kit de accesorios, disyuntores de circuitos, módem celular, cables y gabinete.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios es para un sitio típico y no incluye una actualización del panel principal y techo de tipo especial.'
            }
          }
        },
        storage: {
          indicativePricing: 'Rango de precios indicativo por kWhr',
          main: 'Almacenamiento - Instalación',
          quoteSizeIn: 'kWh',
          sub: 'Una nueva instalación de sistema de almacenamiento',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub:
                'Proporciona precios llave en mano y consigue toda la lista de materiales, tales como almacenamiento ACB, soporte, cableado y disyuntores de circuitos.'
            },
            assumptions: {
              principal: '‘Supuestos',
              sub: 'El rango de precios indicativo no incluye la actualización del panel principal.'
            }
          }
        },
        microinverter: {
          indicativePricing: '‘Rango de precios indicativo por Watt',
          main: 'Microinversor - Actualización',
          quoteSizeIn: 'kW',
          sub:
            'Actualización del microinversor para un sistema solar en base a la serie M (por ejemplo M-215, M-250) a un nuevo sistema solar en base a IQ que a menudo acompaña un "Almacenamiento - Instalación"',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona precios llave en mano y consigue toda la lista de materiales requeridos.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal y actualizaciones del panel solar.'
            }
          }
        },
        solarExpansion: {
          indicativePricing: 'Rango de precios indicativo por Watt',
          quoteSizeIn: 'kW',
          main: 'Ampliación del sistema solar',
          sub: 'Ampliación de sistemas solares de Enphase y externos de Enphase existentes',
          details: {
            homeOwner: {
              main: '',
              sub: ''
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona precios llave en mano y consigue toda la lista de materiales requeridos.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios es para un sitio típico y no incluye una actualización del panel principal y techo de tipo especial.'
            }
          }
        }
      },
      installationOnly: {
        title: 'Solo servicios de instalación (para programas especiales)',
        sub:
          '(por ejemplo, sistemas de Orphan necesitan reemplazos/reparaciones, actualización de baterías, actualización de Envoy)',
        description:
          'Solo servicios de instalación significa que el propietario de vivienda consigue la lista de materiales de Enphase de la tienda de Enphase. Todos los demás materiales y servicios son proporcionados directamente por el instalador (cableado, gabinetes, diseño, permisos, instalación y puesta en servicio según corresponda).',
        solar: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          main: 'Solar - Instalación',
          sub:
            'Nuevas instalaciones para programas especiales, tales como clientes potenciales recomendados por clientes, instaladores y empleados de Enphase.',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase\u200b, tales como microinversores, kit de accesorios, Envoy y disyuntores de circuitos.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona módulos, gabinete, cableado, permisos, instalación y puesta en servicio.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal e instalación de techo de tipo especial.'
            }
          }
        },
        storage: {
          quoteSizeIn: 'kWh',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          main: 'Almacenamiento – Ampliación o Instalación',
          sub: 'Ampliación de almacenamiento ACB o instalación a un sistema solar existente para programas especiales',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase\u200b, tales como almacenamiento ACB, soporte.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona instalación y puesta en servicio.'
            },
            assumptions: {
              main: 'Supuestos',
              sub: 'El rango de precios indicativo no incluye la actualización del panel principal.'
            }
          }
        },
        microinverter: {
          quoteSizeIn: 'kW',
          indicativePricing: 'Rango de precios indicativo de instalación solamente por Watt',
          main: 'Microinversores - Actualización',
          sub:
            'Actualización del microinversor para un sistema solar en base a M-190/M-210/M-175/D380 a un nuevo sistema solar en base a IQ que a menudo acompaña un "Almacenamiento - Instalación"\'',
          details: {
            homeOwner: {
              main: 'Propietario de vivienda',
              sub:
                'Las compras requirieron una lista de materiales de la tienda de Enphase\u200b, tales como microinversores, caja IQ\u200b Combiner, kit de accesorios y disyuntores de circuitos.'
            },
            installer: {
              main: 'Instalador',
              sub: 'Proporciona permisos, reemplazos, nueva puesta en servicio y reciclaje de microinversores viejos.'
            },
            assumptions: {
              main: 'Supuestos',
              sub:
                'El rango de precios indicativo no incluye la actualización del panel principal y cambios de gabinete.'
            }
          }
        }
      },
      omServices: {
        title: 'Servicios de O&M de Enphase ',
        om: {
          main: 'Aceptar los Servicios de O&M de Enphase',
          pre: '- Incluidos los Sistemas Orphan',
          sub:
            'Los servicios de operaciones y mantenimiento (O&M) incluyen el soporte y mantenimiento de sistemas de Enphase existentes y Sistemas Orphan (sitios con un instalador inactivo). Se le proporcionará a todos los clientes potenciales de O&M detalles completos del sitio e historial de soporte. Para todos los clientes potenciales de O&M, se aplicará la garantía del producto estándar de Enphase.'
        }
      },
      otherServices: {
        title: 'Otras preferencias',
        buy: 'Estoy dispuesto a comprar productos de',
        acModule: {
          main: 'Estoy dispuesto a instalar Módulos de CA energizados de Enphase',
          sub1: 'Los Módulos de CA energizados de Enphase\xa0',
          sub2:
            'combinan la tecnología más reciente de microinversores de Enphase con los Paneles solares de alta eficiencia. Combinan estética y rendimiento en un producto elegante que reduce el tiempo de instalación al combinar el inversor y panel en una única unidad. Al seleccionar esta opción, Enphase lo contactará con los propietarios de vivienda que estén dispuestos a instalar Módulos de CA.'
        },
        enstore: {
          main: 'Tienda de Enphase',
          sub1: 'La Tienda de Enphase\xa0',
          sub2:
            'es un centro integral para productos Solares y de Almacenamiento con entrega garantizada. La Tienda no requiere una cantidad mínima de pedido y proporciona una entrega en tiempo real y seguimiento en línea.'
        },
        distributor: {
          main: 'Distribuidores de Enphase',
          sub1: 'Los Distribuidores de Enphase',
          sub2:
            '\xa0suministran todos los productos de Enphase y otros accesorios requeridos para su solución Solar y de Almacenamiento'
        }
      },
      serviceArea: {
        name: 'AÑADIR ÁREAS DE SERVICIO',
        sub: 'No se añadieron áreas',
        description:
          'Añada sus áreas de servicio. Esto es necesario para que Enphase pueda conectarlo con clientes potenciales propietarios de vivienda.'
      }
    },
    getLink: `Obtenga el enlace`,
    linkSENewLeads: `Enlace de la Calculadora del sistema para clientes potenciales nuevos`,
    shareSELink: `Comparta este enlace con sus clientes para ayudarlos a estimar el tamaño de su sistema Enphase y envíe sus detalles para obtener un cliente potencial en su Gestor de Enlighten`
  }
};

export default leadPreferences;
